<script setup lang="ts">
import type { IDashboardWidgetProps, TWidgetEmits } from '@tenorlab/vue-dashboard'
import { DashboardWidgetBase, useWidgetEmits } from '@tenorlab/vue-dashboard'

const props = defineProps<IDashboardWidgetProps>()
const emits = defineEmits<TWidgetEmits>()
const emitHandlers = useWidgetEmits(emits)

const items: {
  id: string
  name: string
  percentValue: number
  className: string
}[] = [
  {
    id: 'product1',
    name: 'Donuts',
    percentValue: 25,
    className: 'dashboard-progress bg-primary content-primary',
  },
  {
    id: 'product2',
    name: 'Croissants',
    percentValue: 35,
    className: 'dashboard-progress bg-primary content-primary',
  },
  {
    id: 'product3',
    name: 'Cappuccinos',
    percentValue: 55,
    className: 'dashboard-progress bg-primary content-primary',
  },
  {
    id: 'product4',
    name: 'Coffee',
    percentValue: 75,
    className: 'dashboard-progress bg-primary content-primary',
  },
  {
    id: 'product5',
    name: 'Bagels',
    percentValue: 65,
    className: 'dashboard-progress bg-primary content-primary',
  },
]
</script>

<template>
  <DashboardWidgetBase v-bind="props" v-on="emitHandlers">
    <div class="flex flex-col gap-2">
      <div v-for="item in items" :key="item.id" class="flex flex-col">
        <span class="ml-1 font-semibold text-xs">
          {{ item.name }}
        </span>
        <div class="dashboard-progress-bar bg-cardchild flex items-center">
          <div :class="item.className" :style="`width: ${item.percentValue}%`"></div>
        </div>
      </div>
    </div>
    <div class="text-sm">~87% of sales reported</div>
  </DashboardWidgetBase>
</template>
